<template>
  <div>
    <!-- Loading Overlay -->
    <div class="loading-overlay">
      <div class="loading-content">
        <div>Downloading, please wait...</div>
      </div>
    </div>

    <!-- Admit Card Container -->
    <div id="speaker">
      <section class="admit-card-section">
        <div class="admit-card-container">
          <div class="row bg">
            <!-- Row 1: Header Section -->
            <div class="col-md-12">
              <div class="row header-row">
                <!-- Left Column: CU Logo -->
                <div class="col-md-4 header-left-column">
                  <img
                    alt="CU Logo"
                    class="university-logo"
                    src="../../theme-assets/images/logo/cu_logo_black.png"
                  >
                </div>
                

                <!-- Center Column: University Name & Admission Info -->
                <div class="col-md-4 header-center-column">
                  <h4 class="bangla-text-bold university-name">
                    চট্টগ্রাম বিশ্ববিদ্যালয়
                  </h4>
                  <div class="bangla-text admission-title">
                    ১ম বর্ষ স্নাতক (সম্মান) ভর্তি পরীক্ষা, শিক্ষাবর্ষ: ২০২৫-২০২৬
                  </div>
                   <div class="bangla-text-bold admit-card-title">
                প্রবেশ পত্র
              </div>
                </div>

                <!-- Right Column: QR Code & Unit Info -->
                <div class="col-md-4 header-right-column">
                  <div class="qr-code-container" ref="qrCodeUrl" id="qrCodeUrl"></div>
                  <div class="english-text-bold unit-text">
                    Unit {{ $route.params.unit }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 2: Admit Card Title & Instructions -->
            <div class="col-md-12">
             
              <div class="bangla-text-bold instruction-paragraph">
                পরীক্ষা হলে প্রবেশের পূর্বে নিচের নির্দেশাবলী সতর্কতার সাথে পড়ুন এবং পরীক্ষা চলাকালীন সময়ে সেগুলো মেনে চলুন। নির্দেশাবলী অমান্য করলে পরীক্ষা থেকে বহিষ্কারসহ প্রয়োজনীয় শাস্তিমূলক ব্যবস্থা নেওয়া হবে।
              </div>
            </div>

            <!-- Row 3: Roll Numbers Section -->
            <div class="col-md-12">
              <div class="row roll-numbers-row">
                <div class="col-md-6">
                  <div class="english-text roll-number-section">
                    Admission Test Roll No:
                    <span class="roll-digit">{{ studentInfo.exam_roll.charAt(0) }}</span>
                    <span class="roll-digit">{{ studentInfo.exam_roll.charAt(1) }}</span>
                    <span class="roll-digit">{{ studentInfo.exam_roll.charAt(2) }}</span>
                    <span class="roll-digit">{{ studentInfo.exam_roll.charAt(3) }}</span>
                    <span class="roll-digit">{{ studentInfo.exam_roll.charAt(4) }}</span>
                    <span class="roll-digit roll-digit-last">{{ studentInfo.exam_roll.charAt(5) }}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="english-text application-id-section">
                    Application ID:
                    <span class="roll-digit">{{ studentInfo.applicant_no.charAt(0) }}</span>
                    <span class="roll-digit">{{ studentInfo.applicant_no.charAt(1) }}</span>
                    <span class="roll-digit">{{ studentInfo.applicant_no.charAt(2) }}</span>
                    <span class="roll-digit">{{ studentInfo.applicant_no.charAt(3) }}</span>
                    <span class="roll-digit">{{ studentInfo.applicant_no.charAt(4) }}</span>
                    <span class="roll-digit roll-digit-last">{{ studentInfo.applicant_no.charAt(5) }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 4: Student Information & Photo -->
            <div class="col-md-12">
              <div class="row student-details-row">
                <!-- Left Column: Student Info & Exam Info -->
                <div class="col-md-8 student-info-column">
                  <div class="bangla-text student-info-row student-name-row">
                    পরীক্ষার্থীর নাম: <span class="english-text">{{ studentInfo.name }}</span>
                  </div>
                  <div class="bangla-text student-info-row">
                    পিতার নাম: <span class="english-text">{{ studentInfo.father_name }}</span>
                  </div>
                  <div class="bangla-text student-info-row">
                    মাতার নাম: <span class="english-text">{{ studentInfo.mother_name }}</span>
                  </div>
                  <div class="bangla-text exam-info-box">
                    পরীক্ষার অঞ্চল: {{ studentInfo.exam_center }}<br>
                    পরীক্ষার তারিখ: {{ studentInfo.exam_date }}<br>
                    সময়: {{ studentInfo.exam_time }}
                  </div>
                </div>

                <!-- Right Column: Photo & Signature -->
                <div class="col-md-4 photo-signature-column">
                  <div class="photo-section">
                    <img
                      alt="Student Photo"
                      :src="studentInfo.photo"
                      class="student-photo"
                    >
                  </div>
                  <div class="signature-section">
                    <img
                      alt="Signature"
                      :src="studentInfo.signature"
                      class="student-signature"
                    >
                    <div class="bangla-text signature-label">
                      পরীক্ষার্থীর স্বাক্ষর
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 5: Instructions -->
            <div class="col-md-12 instructions-row">
              <div class="instructions-section">
                <ul class="bangla-text instructions-list">
                  <li>
                    ১। উত্তরপত্রে লেখার কাজে কালো কালির বলপয়েন্ট কলম ব্যবহার করতে হবে। পেন্সিল অথবা তরল কালির কলম ব্যবহার সম্পূর্ণভাবে নিষিদ্ধ।
                  </li>
                  <li>
                    ২। ⁠পরীক্ষা কেন্দ্রে প্রবেশের জন্য ও পরীক্ষায় অংশগ্রহনের জন্য এই প্রবেশপত্রের এক কপি রঙিন অথবা সাদাকালো প্রিন্ট এবং উচ্চ মাধ্যমিক শিক্ষা বোর্ডের মূল রেজিস্ট্রেশন কার্ড অথবা <span class="english-text">A</span>-লেভেলের <span class="english-text">Statement of Entry</span>-র মূল কপি সাথে আনতে হবে। পরীক্ষায় অংশগ্রহনের সময় পরীক্ষা কেন্দ্রের পরিদর্শককে চাহিদা অনুযায়ী এ সকল কাগজপত্র প্রদর্শন করতে হবে।
                  </li>
                  <li>
                    ৩। পরীক্ষায় সহায়ক হিসাবে ব্যবহারের জন্য <span class="english-text">FX-100</span>  বা এর নিচের মানের ক্যালকুলেটর ব্যবহার করা যাবে, তবে সিম বা অন্য কোন যোগাযোগ প্রযুক্তি সমৃদ্ধ এবং প্রোগ্রামেবল ক্যালকুলেটর ব্যবহার করা যাবে না। পরীক্ষার সময় মোবাইল ফোন, স্মার্ট ওয়াচ, যে কোন ধরনের যোগাযোগ যন্ত্র বা অন্য ইলেকট্রনিক ডিভাইস/গ্যাজেট সাথে রাখা সম্পূর্ণ নিষিদ্ধ।
                  </li>
                  <li>
                    ৪।  ⁠সনাক্তকরণের স্বার্থে পরীক্ষার্থীর মুখমন্ডল ও উভয় কান দৃশ্যমান থাকতে হবে।
                  </li>
                  <li>
                    ৫। ⁠আবেদনের সময় (অথবা পরবর্তীতে সংশোধনের সময়) ভর্তির ওয়েবসাইটে আপলোডকৃত ছবি ও স্বাক্ষরই চুড়ান্ত বলে গণ্য হবে। সংশোধনের নির্ধারিত সময় শেষ হবার পর কোন অবস্থাতেই ছবি বা স্বাক্ষর পরিবর্তন করা যাবে না।
                  </li>
                  <li>
                    ৬। পরীক্ষার হলে পরিদর্শক বা প্রধান পরিদর্শকের সিদ্ধান্তই চুড়ান্ত বলে গণ্য হবে।
                  </li>
                  <li>
                    ৭। পরীক্ষার কেন্দ্র, ভবন, কক্ষ নম্বর; পরীক্ষার ফলাফল; সাক্ষাৎকারের তারিখ ও স্থান; সাময়িক ও চুড়ান্ত ভর্তির যাবতীয় তথ্য ইত্যাদি উপযুক্ত সময়ে অ্যাডমিশান ওয়েবসাইটে ( <span class="english-text">admission.cu.ac.bd</span>) প্রদর্শিত হবে। পরীক্ষার্থীদের নিজ নিজ দায়িত্বে যথাসময়ে ওয়েবসাইট হতে তথ্য সংগ্রহ করতে হবে।
                  </li>
                  <li>
                    ৮। েত্রবিশেষে আবেদনকারী/পরীক্ষার্থীদের প্রদত্ত মোবাইল ফোনে ক্ষুদ্র বার্তার মাধ্যমে জরূরী সংবাদ প্রদান করা হবে, আবেদনের সময় থেকে ভর্তি প্রক্রিয়া সম্পূর্ণ শেষ না হওয়া পর্যন্ত মোবাইল ফোনটি সচল রাখার দায়িত্ব সংশ্লিষ্ট আবেদনকারী/পরীক্ষার্থীর।
                  </li>
                </ul>
              </div>
            </div>

            <!-- Row 6: Footer Section -->
            <div class="col-md-12">
              <div class="row footer-row">
                <!-- Left Column: Download Info -->
                <div class="col-md-6 footer-left-column">
                  <div class="bangla-text download-info">
                    ডাউনলোডের তারিখ: <span class="download-date">{{ studentInfo.admitcard_download_date }}</span>
                    <br><br>
                    <span class="english-text powered-by-text">
                      Powered by <b>ICT Cell, University of Chittagong</b>
                    </span>
                  </div>
                </div>

                <!-- Right Column: Coordinator Info -->
                <div class="col-md-6 footer-right-column">
                  <img
                    alt="Coordinator Signature"
                    class="coordinator-signature"
                    :src="studentInfo.co_ordinator_signature"
                  >
                  <div class="bangla-text coordinator-info">
                    {{ studentInfo.unit_co_ordinator }}<br>
                    কো-অর্ডিনেটর<br>
                    <span class="english-text">{{ $route.params.unit }}</span>
                    {{ $route.params.unit.charAt(1) ? 'উপ-' : '' }}ইউনিট ভর্তি কমিটি
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Loader from '../Helper/Loader'
import Banner from '../Partial/Banner'
import { GET_ADMIT_CARD_DATA, GET_DOCS, GET_ADMIT_CARD } from '../../const/api'
import { GET } from '../../utils/Request'
import QRCode from 'qrcodejs2'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export default {
  name: 'AdmitCard',
  components: {
    Loader,
    Banner
  },
  data() {
    return {
      firstTimeLoad: true,
      qrText: '',
      studentInfo: {
        hash_key: '',
        applicant_no: '',
        co_ordinator_signature: '',
        exam_date: '',
        exam_roll: '',
        exam_time: '',
        exam_center: '',
        exam_center_name: '',
        father_name: '',
        group: '',
        mother_name: '',
        name: '',
        photo: '',
        signature: '',
        status: '',
        unit_co_ordinator: '',
        medium: '',
        admitcard_download_date: '',
        admitcard_download_time: ''
      }
    }
  },
  computed: {
    isOnHomepage() {
      const routeName = this.$route.name
      return routeName === 'home'
    }
  },
  created() {
    this.getDocs()
  },
  mounted() {
    // Component mounted
  },
  methods: {
    async downloadPDF() {
      try {
        const element = document.querySelector('#speaker')

        // Ensure all remote images are loaded before rendering canvas
        const images = element.querySelectorAll('img')
        await Promise.all(
          Array.from(images).map((img) => {
            if (!img.complete) {
              return new Promise((resolve, reject) => {
                img.onload = resolve
                img.onerror = reject
              })
            }
          })
        )

        // Optimize images before rendering
        await this.optimizeImages(element)

        // Render HTML to canvas with optimized settings
        const canvas = await html2canvas(element, {
          scale: 1.5, // Balanced quality vs size
          useCORS: true,
          allowTaint: true,
          logging: false,
          backgroundColor: '#ffffff',
          removeContainer: true,
          imageTimeout: 0
        })

        // Convert to JPEG with compression
        const imgData = canvas.toDataURL('image/jpeg', 0.85)

        // Create PDF with compression
        const pdf = new jsPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'a4',
          compress: true
        })

        // Calculate width and height to maintain aspect ratio
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width

        // Add image as JPEG for smaller file size
        pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST')
        pdf.save(`cu_admit_card_${this.studentInfo.exam_roll}.pdf`)

        // Small delay to ensure save finished, then close window
        setTimeout(() => {
          window.close()
        }, 1000)
      } catch (err) {
        console.error('PDF generation failed', err)
        this.$iziToast.error({ message: 'Failed to generate PDF. Try again.' })
      }
    },

    async optimizeImages(container) {
      const images = container.querySelectorAll('img')

      for (const img of images) {
        if (!img.complete || !img.naturalWidth) continue

        try {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')

          const rect = img.getBoundingClientRect()
          const maxWidth = rect.width * 1.5
          const maxHeight = rect.height * 1.5

          let width = img.naturalWidth
          let height = img.naturalHeight

          if (width > maxWidth || height > maxHeight) {
            const ratio = Math.min(maxWidth / width, maxHeight / height)
            width = width * ratio
            height = height * ratio
          }

          canvas.width = width
          canvas.height = height
          ctx.drawImage(img, 0, 0, width, height)

          const isSignature = img.alt && img.alt.toLowerCase().includes('signature')
          const quality = isSignature ? 0.9 : 0.85
          const format = isSignature ? 'image/png' : 'image/jpeg'

          img.src = canvas.toDataURL(format, quality)
        } catch (error) {
          console.warn('Failed to optimize image:', error)
        }
      }

      // Wait for optimized images to load
      await new Promise(resolve => setTimeout(resolve, 300))
    },

    async getDocs() {
      this.$route.params.unit = this.$route.params.unit.toUpperCase()
      const data = await GET(GET_ADMIT_CARD_DATA + this.$route.params.unit)

      if (data.data.status === 'success') {
        this.studentInfo.applicant_no = String(data.data.application_id)
        this.studentInfo.exam_date = data.data.exam_date
        this.studentInfo.exam_roll = String(data.data.exam_roll)
        this.studentInfo.exam_time = data.data.exam_time
        this.studentInfo.exam_center = data.data.exam_center
        this.studentInfo.exam_center_name = data.data.exam_center_name
        this.studentInfo.father_name = data.data.father_name
        this.studentInfo.group = data.data.group
        this.studentInfo.mother_name = data.data.mother_name
        this.studentInfo.name = data.data.name
        this.studentInfo.medium = data.data.medium
        this.studentInfo.hash_key = data.data.hash_key
        this.studentInfo.photo = data.data.photo
        this.studentInfo.signature = data.data.signature
        this.studentInfo.unit_co_ordinator = data.data.unit_co_ordinator
        this.studentInfo.co_ordinator_signature = data.data.co_ordinator_signature

        const today = new Date()
        this.studentInfo.admitcard_download_date = data.data.download_date

        if (data.data.download_time) {
          this.studentInfo.admitcard_download_time = data.data.download_time
        } else {
          let amOrPm = 'AM'
          let hour = today.getHours()
          if (hour > 11) {
            amOrPm = 'PM'
            if (hour > 12) {
              hour -= 12
            }
          }
          let mins = today.getMinutes()
          if (mins < 10) {
            mins = '0' + mins
          }
          this.studentInfo.admitcard_download_time = `${hour}:${mins}${amOrPm}`
        }

        this.qrText = `${process.env.VUE_APP_FRONTEND_URL}check-admit-card/${data.data.hash_key}`
      } else {
        this.$iziToast.error({
          message: data.data.message
        })
        this.goForUrl('/')
      }
      await this.timeoutForLoading()
    },

    goForUrl(url) {
      this.$router.replace(url)
    },

    topFunction() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },

    async timeoutForLoading() {
      if (this.firstTimeLoad) {
        await this.$nextTick()
        await this.getQR()
        await document.fonts.load('16px "Tiro Bangla"')
        this.downloadPDF()
      }
      this.firstTimeLoad = false
    },

    getQR() {
      return new Promise((resolve) => {
        const canvasDiv = document.createElement('div')
        canvasDiv.id = 'canvas'
        document.getElementById('qrCodeUrl').append(canvasDiv)

        new QRCode('canvas', {
          text: this.qrText,
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })

        // Wait a tick for the canvas to render
        this.$nextTick(() => {
          resolve()
        })
      })
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Tiro+Bangla:ital@0;1&family=Courier+Prime:wght@400;700&display=swap');

/* ============================================
   FONT CLASSES
   ============================================ */
.bangla-text {
  font-family: "Tiro Bangla", serif;
  font-weight: 400;
  font-style: normal;
}

.bangla-text-bold {
  font-family: "Tiro Bangla", serif;
  font-weight: 700;
  font-style: normal;
}

.english-text {
  font-family: "Courier Prime", "Courier New", Courier, monospace;
  font-weight: 400;
  font-style: normal;
}

.english-text-bold {
  font-family: "Courier Prime", "Courier New", Courier, monospace;
  font-weight: 700;
  font-style: normal;
}

/* ============================================
   LOADING OVERLAY
   ============================================ */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  text-align: center;
}

.loading-content div {
  font-size: 18px;
  color: #000;
  padding: 15px 30px;
  border: 2px solid #000;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}

/* ============================================
   ADMIT CARD CONTAINER
   ============================================ */
#speaker {
  position: absolute;
  left: -9999px;
  top: -9999px;
  padding: 20px;
  width: 1240px;
  height: 1754px;
  box-sizing: border-box;
}

.admit-card-container {
  padding: 45px;
  margin: auto;
  border: 1px solid black;
  height: 1550px;
}

/* Background Image */
.bg {
  background-image: url("../../theme-assets/images/logo/cu_bg_logo.png");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* ============================================
   ROW 1: HEADER SECTION
   ============================================ */
.header-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.header-left-column {
  text-align: center;
}

.university-logo {
  width: 75px;
  margin-top: 5px;
}

.header-center-column {
  text-align: center;
}

.university-name {
  text-transform: unset;
  color: black;
  font-size: 30px;
  margin: 0;
  padding: 0;
}

.admission-title {
  font-size: 16px;
  color: black;
  padding: 5px 0;
  margin: 0;
}

.header-right-column {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-code-container {
  margin-bottom: 5px;
}

.unit-text {
  color: black;
  font-size: 18px;
  margin: 0;
}

/* ============================================
   ROW 2: ADMIT CARD TITLE & INSTRUCTIONS
   ============================================ */
.admit-card-title {
  text-align: center;
  font-size: 48px;
  color: black;
  padding: 10px 0;
  margin: 10px 0;
}

.instruction-paragraph {
  text-align: justify;
  font-size: 14px;
  color: black;
  padding: 10px 0;
  margin: 10px 0;
  line-height: 1.6;
}

/* ============================================
   ROW 3: ROLL NUMBERS
   ============================================ */
.roll-numbers-row {
  margin: 15px 0;
}

.roll-number-section,
.application-id-section {
  font-size: 20px;
  color: black;
}

.application-id-section {
  text-align: right;
}

.roll-digit {
  border: 2px solid black;
  border-right: 1px solid black;
  padding: 2px 7px;
}

.roll-digit-last {
  border-right: 2px solid black;
}

/* ============================================
   ROW 4: STUDENT INFORMATION & PHOTO
   ============================================ */
.student-details-row {
  margin: 20px 0;
}

.student-info-column {
  padding-right: 20px;
}

.student-info-row {
  color: black;
  padding: 15px 10px 10px 0;
  font-size: 16px;
}

.student-name-row {
  padding-top: 10px;
}

.exam-info-box {
  color: black;
  padding: 10px;
  text-align: center;
  border: 2px solid black;
  max-width: 300px;
  margin-top: 15px;
  font-size: 16px;
  line-height: 1.8;
}

.photo-signature-column {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.photo-section {
  margin-bottom: 15px;
}

.student-photo {
  width: 180px;
  border: 1px solid gray;
  padding: 1px;
  max-width: 100%;
}

.signature-section {
  text-align: center;
}

.student-signature {
  width: 150px;
  display: block;
  margin: 0 auto;
}

.signature-label {
  border-top: 1px dashed black;
  width: 150px;
  margin: 2px auto 0;
  font-size: 14px;
  padding-top: 2px;
}

/* ============================================
   ROW 5: INSTRUCTIONS
   ============================================ */
.instructions-row {
  margin: 25px 0 20px 0;
}

.instructions-section {
  padding: 0;
}

.instructions-list {
  font-size: 14px;
  color: black;
  margin: 0;
  padding-left: 20px;
  text-align: justify;
}

.instructions-list li {
  margin-bottom: 8px;
  line-height: 1.6;
}

/* ============================================
   ROW 6: FOOTER
   ============================================ */
.footer-row {
  margin-top: 30px;
  display: flex;
  align-items: flex-end;
}

.footer-left-column {
  display: flex;
  align-items: flex-end;
}

.download-info {
  color: black;
  font-size: 17px;
}

.download-date {
  font-weight: bold;
}

.powered-by-text {
  font-style: italic;
  font-size: 15px;
}

.footer-right-column {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.coordinator-signature {
  width: 160px;
  margin-bottom: 5px;
  max-width: 100%;
}

.coordinator-info {
  text-align: center;
  line-height: 1.4;
  color: black;
  padding-top: 5px;
  font-size: 17px;
}

/* ============================================
   UTILITY CLASSES
   ============================================ */
* {
  box-sizing: border-box;
}
</style>
